module.exports = __webpack_public_path__ + "static/media/37-iveco.ad4babcb.jpg";